import { createGlobalStyle } from 'styled-components';

import background from 'assets/background.png';

import Calistoga400Woff from 'assets/fonts/Calistoga-Regular.woff';
import Calistoga400Woff2 from 'assets/fonts/Calistoga-Regular.woff2';

import PTSans400Woff from 'assets/fonts/pt-sans-400.woff';
import PTSans400Woff2 from 'assets/fonts/pt-sans-400.woff2';

import PTSans700Woff from 'assets/fonts/pt-sans-700.woff';
import PTSans700Woff2 from 'assets/fonts/pt-sans-700.woff2';

import PTSerif400Woff from 'assets/fonts/pt-serif-400.woff';
import PTSerif400Woff2 from 'assets/fonts/pt-serif-400.woff2';

import PTSerif700Woff from 'assets/fonts/pt-serif-700.woff';
import PTSerif700Woff2 from 'assets/fonts/pt-serif-700.woff2';

import PTSerif700ItalicWoff from 'assets/fonts/pt-serif-700italic.woff';
import PTSerif700ItalicWoff2 from 'assets/fonts/pt-serif-700italic.woff2';

import media from './oldpantheon/utils/media';
import { COLOR_GRAY_TEXT, BLACK } from './theme';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Calistoga';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Calistoga Regular'), local('Calistoga-Regular'),
         url(${Calistoga400Woff2}) format('woff2'),
         url(${Calistoga400Woff}) format('woff');
  }
  @font-face {
    font-family: 'PT Sans';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('PT Sans Regular'), local('PT-Sans-Regular'),
         url(${PTSans400Woff2}) format('woff2'),
         url(${PTSans400Woff}) format('woff');
  }
 @font-face {
    font-family: 'PT Sans';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local('PT Sans Regular'), local('PT-Sans-Regular'),
         url(${PTSans700Woff2}) format('woff2'),
         url(${PTSans700Woff}) format('woff');
  }
  @font-face {
    font-family: 'PT Serif';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('PT Serif Regular'), local('PT-Serif-Regular'),
         url(${PTSerif400Woff2}) format('woff2'),
         url(${PTSerif400Woff}) format('woff');
  }
   @font-face {
    font-family: 'PT Serif Bold';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local('PT Serif'), local('PT-Serif'),
         url(${PTSerif700Woff2}) format('woff2'),
         url(${PTSerif700Woff}) format('woff');
  }
  @font-face {
    font-family: 'PT Serif Italic';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local('PT Serif Italic'), local('PT-Serif-Italic'),
         url(${PTSerif700ItalicWoff2}) format('woff2'),
         url(${PTSerif700ItalicWoff}) format('woff');
  }
  html, body, #root {
    height: 100%;
    font-size: 1rem;
    line-height: 1.5;
  }
  * {
    box-sizing: border-box;
  }
  h1 {
    color: ${BLACK};
    font-family: 'Calistoga', helvetica, arial, sans-serif;
    margin-top: 0;
    margin-bottom: 1rem;
    letter-spacing: 0.03rem;
    ${media.tablet`font-size: 1.5rem;`}
  }
  h2 {
    color: ${BLACK};
    font-family: 'Calistoga', helvetica, arial, sans-serif;
    margin-top: 0;
    margin-bottom: 1rem;
    letter-spacing: 0.5px;
    ${media.tablet`font-size: 1.5rem;`}
  }
  h3 {
    color: ${BLACK};
    font-family: 'PT Serif', helvetica, arial, sans-serif;
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.125rem;
  }
  body {
      background-color: #F1FEFF;
      background-image: url(${background});
      background-repeat: no-repeat;
      background-size: cover;
      font-family: 'PT Sans', helvetica, arial, sans-serif !important;
      font-weight: 400;
      color: ${COLOR_GRAY_TEXT};
      ${media.extraSmall`
        background-size: 43.75rem;
      `}
    }
  .HomeMidAd {
    display: none;
    width: 0;
  }
  .HomeLeftAd {
    text-align: center;
    margin-right: 1rem;
    width: 300px;
  }
  .HomeRightAd {
    text-align: center;
    margin-left: 1rem;
    width: 300px;
  }
  @media (max-width: 1150px) {
    .HomeLeftAd {
      display: none;
      width: 0;
    }
    .HomeRightAd {
      display: none;
      width: 0;
    }
    .HomeMidAd {
      display: block;
      min-width: 300px;
      max-width: 336px;
      margin: 2rem auto 0;
    }
  }
  .SquareAd {
    min-width: 300px;
    max-width: 336px;
    min-height: 250px;
    margin: 10px auto;
    display: block;
  }
  .VerticalAd {
    display: block;
    width: 300px;
    min-height: 600px;
    @media only screen and (max-width: 1075px) {
      width: 160px;
    }
    @media only screen and (max-width: 800px) { 
      display: none;
    }
  }
  
  .BannerAd {
    width: 970px;
    height: 250px;
    display: block;

    @media only screen and (max-width: 1000px) {
      width: 728px;
      height: 90px;
    }
    @media only screen and (max-width: 775px) {
      width: 320px;
      height: 50px;
    }
    @media only screen and (max-width: 500px) {
      width: 320px;
      height: 50px;
    }

  }

  .center {
    text-align: center;
    margin: 0 auto;
    display: block;
    ins {
      margin: 0 auto !important;
      display: block;
    }
  }
`;

export default GlobalStyles;
